// Site version — bump "version" in package.json for every release (semantic: major.minor.patch).
export const APP_VERSION = `V${__APP_VERSION__}`;
/** Platform name: Contrail — the telematics tracking system designed and built by Skyward Industries.
 *  Tracking Fiji stays the customer-facing brand; Contrail shows in the footer and the build name (not on reports). */
export const PLATFORM = "Contrail";
export const BUILD_NAME = `${PLATFORM}_${APP_VERSION}`;

/** What's new — CUSTOMER-FACING notes only (Tracking Fiji is public now). Newest first; the footer shows the newest few.
 *  Rules (Kevin, V3.10.0): only new features useful to customers, in plain short words. No admin/staff-only items, no fixes or
 *  things that should already have worked, no internal names. A release with nothing for customers gets no line.
 *  Confirm the wording with Kevin before each release. Full technical notes live in the build log. */
export const RELEASE_NOTES: [string, string][] = [
  ["V3.12.0", "The map now shows 'No signal' when a tracker goes quiet, and catches up by itself when you come back to the app."],
  ["V3.10.2", "One sign-in for several companies: owners who run more than one company now see them all together."],
  ["V3.9.6", "Tracking Fiji now runs on Contrail, our new tracking platform."],
  ["V3.9.4", "Change your password any time from the account menu (click your email, top right)."],
  ["V3.9.3", "Team chat: message your colleagues and @mention them from the online menu."],
  ["V3.9.2", "See how long a vehicle has been stopped, right next to its status."],
  ["V3.9.1", "New map icons for 12 vehicle and vessel types that turn with the direction of travel."],
  ["V3.9.0", "Hide or show vehicles on the map, find a place from coordinates or a Google Maps link, save your own places, and snooze alerts."],
  ["V3.7.0", "Phone app: add Tracking Fiji to your home screen for the live map, your vehicles and alerts on the go."],
  ["V3.6.0", "A fresh new sign-in page."],
  ["V3.5.0", "Smarter alerts: zone entry and exit, speeding, outside set hours and not moving, by email or in the app."],
  ["V3.4.0", "Speed graph and data log in History. Edit zones corner by corner and export them for other mapping tools."],
  ["V3.3.1", "See which colleagues are online, and a Fleet right now summary on the map."],
  ["V3.3.0", "Zones, a distance ruler, live trails behind each vehicle and your own icon colours."],
  ["V3.2.0", "New printed reports and a map panel you can fold away."],
  ["V3.1.1", "Choose Streets, Hybrid or Satellite maps, including Google maps."],
  ["V3.1.0", "Company page for your logo, contacts and alert recipients. Marine vessels in the fleet register. Direction arrows in History."],
];

/** Known issues shown to customers under "What's new" (V3.10.1, Kevin). Same rules: short, plain, confirmed with Kevin.
 *  Remove a line once the fix is confirmed in the field. */
export const KNOWN_ISSUES: string[] = [
  "On some devices, zones may not show after you return to the map from another page. Switching browser tabs or refreshing the page brings them back.",
];

/** How many of the newest notes the footer shows. */
export const FOOTER_NOTES = 3;
